import Vue from 'vue'
import VueRouter from 'vue-router'
import UserManagementMainWindow from '../components/user-management/MainWindow.vue'
import AdminAddUser from '../components/user-management/AdminAddUser.vue'
import AdminEdit from '../components/user-management/AdminEdit.vue'
import RoleManagementMainWindow from '../components/role-management/MainWindow.vue'
import AddRole from '../components/role-management/AddUserRole.vue'
import EditRole from '../components/role-management/EditUserRole.vue'
import Test from '../components/HelloWorld.vue'
import AssignRole from '../components/role-assign/AddRole.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: UserManagementMainWindow
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  },
  {
    path: '/admin/edit-user/:id',
    name: 'AdminEdit',
    component: AdminEdit
  },
  {
    path: '/admin/add-user',
    name: 'AdminEdit',
    component: AdminAddUser
  },
  {
    path: '/admin/roleManagement',
    name: 'roleManagement',
    component: RoleManagementMainWindow
  },
  {
    path: '/admin/add-role',
    name: 'AddRole',
    component: AddRole
  },
  {
    path: '/admin/edit-role',
    name: 'roleEdit',
    component: EditRole
  },
  {
    path: '/admin/roleAssign',
    name: 'AssignRole',
    component: AssignRole
  },


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
